module.exports = __webpack_public_path__ + "static/media/cases_brand_jardim_02.e96d4168.jpg";